export default {
  velt: {
    openPanel: 'Yorum panelini aç',
    closePanel: 'Yorum panelini kapat',
    panel: 'Yorum paneli',
    tabs: 'Yorum paneli sekmeleri',
    comments: 'Yorumlar',
    settings: 'Ayarlar ve İzinler',
    dragOrTapComment: 'Yorum eklemek için sürükleyin veya yorumları görmek için dokunun',
    assignComment: 'Yorumu ata',
    markAsUnread: 'Okunmadı olarak işaretle',
    markAsRead: 'Okundu olarak işaretle',
    unsubscribe: 'Abonelikten çık',
    subscribe: 'Abone ol',
    deleteThread: 'Konuyu sil',
    editComment: 'Yorumu düzenle',
    emptyPlaceholder: 'Geri bildirim verin, soru sorun veya ekip üyeleriniz için bir not bırakın',
    searchPlaceholder: 'Yorumlarda ara',
    commentPlaceholder: '{page} hakkında yorum yap',
    replyPlaceholder: 'Yanıtla....',
    filterPages: 'Sayfalar',
    filterAuthor: 'Yazar',
    filterTagged: 'Etiketlenenler',
    statusOpen: 'Açık',
    statusResolved: 'Çözüldü',
    anonymous: 'Anonim',
    settingsPanel: {
      title: 'Kimler yorum yapabilir?',
      everyoneLabel: 'Herkes',
      restrictedLabel: 'Yalnızca davet edilen iş birlikçiler',
      emailsLabel: 'E-postalar',
      emailsPlaceholder: 'Bir e-posta ekleyin ve Enter\'a basın',
    },
  },
}
